<div class="panel" [class.active]="toggle.checked">
  <app-form-switch
    labelPosition="before"
    [inline]="!toggle.checked || viewType === 'table'"
    [formControl]="form.get('status')"
    [matTooltip]="customTooltip || getTooltip()"
    [disabled]="(isEditing$ | async) || disabled"
    #toggle
  >
    {{ label }}
  </app-form-switch>
  <ng-container *ngIf="toggle.checked && viewType !== 'table'">
    <div class="row">
      <div class="col-md-6">
        <button class="btn btn-secondary-info" (click)="info.onEditIncident()" [disabled]="isEditing$ | async">
          <i class="cs-icon cs-icon-pencil"></i>
          <ng-container i18n>Edit Incident</ng-container>
        </button>
      </div>
    </div>
  </ng-container>
</div>

<app-autopilot-automation-info
  [automationGroup]="automationGroup"
  [event]="event"
  [eventSourceType]="eventSourceType"
  [incident]="incident"
  (saveData)="onSaveData($event)"
  [class.d-none]="viewType !== 'table'"
  #info
></app-autopilot-automation-info>
